import React, { useEffect, useState } from "react"
import { translate } from "translate/i18n"
import { getRequest } from "utils/request"
import { useNotification } from "hooks/notification"

type Status = {
  id: string | number
  internalDescription: string
}

type SelectStatusForRefusedChatProps = {
  handleInputChange: (event: {
    target: { name: string; value: string }
  }) => void
  statusForRefusedChat: number;
}

export function SelectStatusForRefusedChat(
  props: SelectStatusForRefusedChatProps
): JSX.Element {
  const { selectedCompany } = useNotification()
  const [listStatus, setListStatus] = useState<Status[]>([])
  const [selectedStatus, setSelectedStatus] = useState<number | null>(null)

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedStatus(Number(event.target.value))
    props.handleInputChange({
      target: {
        name: "statusForRefusedChat",
        value: event.target.value,
      },
    })
  }

  useEffect(() => {
    const request = async () => {
      const response = await getRequest<Status[]>(
        `/companiesstatus?CompanyId=${selectedCompany.id}`
      )
      if (response.success) {
        setListStatus(response.data)
      }

      console.log('/companiesstatus?CompanyId=${selectedCompany.id} response & props.statusForRefusedChat', response, props.statusForRefusedChat)

      if (props.statusForRefusedChat) {
        setSelectedStatus(props.statusForRefusedChat)
      }


    }
    request()
  }, [selectedCompany.id, props.statusForRefusedChat])

  return (
    <>
      <label
        className="title-combo-details-client-chat"
        style={{ marginTop: 10 }}
      >
        {translate("statusForRefusedChat")}
      </label>
      <div className="form-row">
        <div className="form-group col-lg-8">
          <select
            className="form-control"
            name="statusForRefusedChat"
            value={selectedStatus ?? ""}
            onChange={handleChange}
          >
            {listStatus.map((data, index) => (
              <option key={index} value={data.id}>
                {data.internalDescription}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  )
}
